import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getStoreDashboard = createAsyncThunk('/party/getStoreDashboard',
    async () => {
        try {
            const myurl = `${V_URL}/user/store-dashboard`;
            const formData = new URLSearchParams();

            formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));

            const response = await axios({
                method: 'post',
                url: myurl,
                data: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;
            // console.log(data, "getStoreDashboard response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getStoreDashboardSlice = createSlice({
    name: "getStoreDashboard",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStoreDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getStoreDashboard.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getStoreDashboard.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getStoreDashboardSlice.reducer;